Customer.Ticket ||= {}

class Customer.Ticket.AttachmentView extends Backbone.View

  initialize: (el, response) ->
    @$el = el
    @response = response
    @files = []

  toJSON: ->
    _.collect @files, (file)-> file.toJSON()

  allFiles: ->
    @files
